import {
  SliderRange,
  SliderRoot,
  SliderThumb,
  SliderTrack,
} from "@jammable/ui-core";
import React, { useState } from "react";
import VoiceImage from "../VoiceImage";

const PitchSlider2 = ({
  handlePitchChange,
  hasPopover,
  pitch,
  voices,
  setPitchScalingForVoice,
}) => {
  const [isThumbHovered, setIsThumbHovered] = useState(false);

  const [selectedVoice, setSelectedVoice] = useState(voices[0]);

  return (
    <div className="tw-pb-2">
      <div className="tw-font-semibold tw-mt-1 tw-flex tw-items-center tw-mb-0.5">
        <span className="tw-tracking-tight tw-flex  tw-items-center">
          Pitch Shift
          <div className="tw-flex tw-gap-0.5 tw-ml-2">
            {voices.map((voice) => {
              return (
                <div
                  key={voice._id}
                  className="tw-relative tw-flex tw-cursor-pointer tw-items-center tw-justify-center"
                  onClick={() => {
                    setSelectedVoice(voice);
                  }}
                >
                  <div className="tw-absolute tw-z-10 tw-drop-shadow-[0_1.2px_3px_rgba(0,0,0,1)]  tw-font-black tw-font-variant-numeric tw-text-white tw-text-xs">
                    {voice.pitchScaling ?? 0}
                  </div>
                  <VoiceImage
                    model={voice}
                    size={30}
                    className={`tw-rounded-lg  tw-transition-all tw-border-2 tw-border-solid  ${selectedVoice._id !== voice._id ? "tw-brightness-50 tw-border-transparent" : "tw-brightness-100 tw-border-black"}`}
                  />
                </div>
              );
            })}
          </div>
        </span>
      </div>

      <SliderRoot
        defaultValue={[0]}
        value={[pitch]}
        min={-24}
        max={24}
        step={1}
        onValueChange={(e) => {
          handlePitchChange(e[0]);

          setPitchScalingForVoice(selectedVoice._id, e[0]);
        }}
        className="tw-w-full  tw-transition-all tw-mt-1.5"
      >
        <SliderTrack className="tw-relative tw-h-5 tw-cursor-pointer tw-transition-all tw-w-full tw-grow tw-overflow-hidden  tw-rounded-lg tw-bg-purple-700/10  ">
          <SliderRange className="tw-absolute tw-h-full tw-bg-transparent tw-transition-all" />
        </SliderTrack>

        <SliderThumb
          className="tw-flex tw-h-7 tw-w-5 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-purple-700/50 tw-bg-purple-700 tw-shadow-xl tw-transition-all focus-visible:tw-outline-none focus-visible:tw-ring-1 hover:tw-scale-110 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50"
          onMouseEnter={() => setIsThumbHovered(true)}
          onMouseLeave={() => setIsThumbHovered(false)}
        >
          {isThumbHovered && hasPopover && (
            <div
              style={{
                zIndex: 1000000000,
              }}
              className="tw-absolute tw-z-100000 tw-normal-nums tw-border tw-border-solid tw-border-gray-200 tw--top-12 tw-shadow-xl tw-rounded-lg tw-bg-gray-100 tw-p-2 tw-px-3 tw-font-black "
            >
              {pitch}
            </div>
          )}
        </SliderThumb>
      </SliderRoot>
      <div className="tw-text-sm tw-text-black/40 md:tw-max-w-md tw-py-1 tw-mt-2">
        <span className="tw-bg-sky-300 tw-p-1.5 tw-text-xs tw-rounded-full tw-mr-1 tw-py-1 tw-font-black tw-text-black/70">
          TIP
        </span>
        Use{" "}
        <span
          onClick={() => {
            handlePitchChange(-12);
            setPitchScalingForVoice(selectedVoice._id, -12);
          }}
          className="tw-font-black tw-underline tw-cursor-pointer"
        >
          -12
        </span>{" "}
        for female to male and{" "}
        <span
          onClick={() => {
            handlePitchChange(12);
            setPitchScalingForVoice(selectedVoice._id, 12);
          }}
          className="tw-font-black tw-underline tw-cursor-pointer"
        >
          +12
        </span>{" "}
        for male to female!
      </div>
    </div>
  );
};

export default PitchSlider2;
